import styled from 'styled-components';

import 'antd/lib/alert/style/index.css';

import 'antd/lib/table/style/index.css';
import 'antd/lib/divider/style/index.css';
import 'antd/lib/tag/style/index.css';

export const BoxTable = styled.div`
  /*
  TABELA / GRID
*/
  .ant-table-tbody tr > td:first-child {
    white-space: nowrap;
  }
  .ant-table-thead * {
    background-color: #f7f7f7;

    span.ant-table-column-title {
      font-size: 12px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.25;
      letter-spacing: 0.01px;
      color: #727272;
      text-align: center;
    }
  }
  .ant-table-row {
    background-color: #fff;
  }

  .ant-table-tbody > tr > td {
    border-bottom: 1px solid #e8e8e8;
    -webkit-transition: all 0.3s, border 0s;
    transition: all 0.3s, border 0s;
    margin-bottom: 7px;
  }
`;
